import { useState, useEffect } from 'react';
import Api from '../api/api';
import { Modal, Button } from 'react-bootstrap';
import stringHelpers from '../../utilities/stringHelpers';
import arrayUtilities from '../../utilities/arrayUtilities';
import formUtilities from '../../utilities/formUtilities';
import { ErrorModal } from '../../utilities/errorModal';
import Loader from '../shared/loader';
export const RegionsLanding = ({ organisationId, token }) => {
    const [regions, setRegions] = useState(null)
    const [errorMessage, setErrorMessage] = useState(null)
    const [isLoading, setIsLoading] = useState(false)
    const [showUpdateModal, setShowUpdateModal] = useState(false)
    const [regionName, setRegionName] = useState("")
    const [regionId, setRegionId] = useState(null)
    const [showDeleteModal, setShowDeleteModal] = useState(false)

    const getRegions = () => {
        setIsLoading(true)
        Api.getRegions(
            data => {
                setRegions(data)
                setIsLoading(false)
            },
            error => {
                console.log(error)
                setIsLoading(false)
            },
            organisationId, token
        )
    }

    useEffect(() => getRegions(), [])

    const handleSubmit = () => {
        setShowUpdateModal(false)
        if (stringHelpers.isNullOrEmpty(regionId)) {
            Api.addRegion(
                data => {
                    if (data.isError) {
                        setErrorMessage(data.errorMessage)
                    } else {
                        getRegions()
                    }
                },
                error => {
                    setErrorMessage(error.message)
                    console.log(error.message)
                },
                regionName,
                organisationId, token
            )
        } else {
            Api.editRegion(
                data => {
                    if (data.isError) {
                        setErrorMessage(data.errorMessage)
                    } else {
                        getRegions()
                    }
                },
                error => {
                    setErrorMessage(error.message)
                    console.log(error.message)
                },
                regionId,
                regionName,
                organisationId, token
            )
        }
        setRegionId(null)
        setRegionName("")

    }

    const handleDelete = () => {
        setShowDeleteModal(false)
        Api.deleteRegion(
            data => {
                if (data.isError) {
                    setErrorMessage(data.errorMessage)
                } else {
                    getRegions()
                }
            },
            error => {
                setErrorMessage(error.message)
                console.log(error.message)
            },
            regionId,
            organisationId, token
        )
    }
    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-12">
                    <div className="card mb-3">
                        <div className="card-header d-flex align-items-center justify-content-between">
                            <h5 className="mb-0">Regions</h5>
                            <button className="btn btn-success btn-sm ml-1 nowrap" onClick={ () => setShowUpdateModal(true) }><i className="fas fa-plus mr-1"></i>Add</button>
                        </div>
                        <div className="card-body bg-light border-top p-0">
                            <table className="table table-sm mb-0 table-striped table-dashboard fs--1 data-table border-bottom border-200 no-footer allow-list-table">
                                <thead className="bg-200 text-900">
                                    <tr>
                                        <th>Name</th>
                                        <th>&nbsp;</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        isLoading
                                            ? <tr><td colSpan={ 2 }><Loader /></td></tr>
                                            : <>
                                                {
                                                    !arrayUtilities.isNullOrEmpty(regions) && regions
                                                        .map(region => <tr>
                                                            <td>{ region.name }</td>
                                                            <td className="text-right pr-3">
                                                                <button onClick={ () => {
                                                                    setRegionId(region.id)
                                                                    setRegionName(region.name)
                                                                    setShowUpdateModal(true)
                                                                } } className='btn p-0'><i className="fas fa-edit mr-2 fs--1"></i></button>
                                                                <button className='btn p-0' onClick={ () => {
                                                                    setRegionId(region.id)
                                                                    setRegionName(region.name)
                                                                    setShowDeleteModal(true)
                                                                } } ><i className="fas fa-trash-alt fs--1"></i>
                                                                </button>
                                                            </td>
                                                        </tr>)
                                                }
                                            </>
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>

            {
                showUpdateModal &&
                <Modal show onHide={ () => {
                    setShowUpdateModal(false)
                    setRegionId(null)
                    setRegionName("")
                } } centered>
                    <Modal.Header>
                        <Modal.Title className="d-flex gap-2 align-items-center">
                            { !stringHelpers.isNullOrEmpty(regionId) ? <>Edit</> : <>Add</> } Region
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="row mb-2">
                            <div className="col-md-3 col-12 ">
                                <p className="font-weight-semi-bold  mt-1 mb-1">Name<span className="req"></span></p>
                            </div>
                            <div className="col-md-9 col-12">
                                <div className="form-group mb-1">
                                    <input required className="form-control mb-0" type="text" autoFocus={ true } value={ regionName } onChange={ (e) => {
                                        setRegionName(e.target.value);
                                        formUtilities.requiredField(e.target.parentNode, e.target.value)
                                    } } />
                                    <small className='invalid-feedback text-danger'>Please enter a name</small>
                                </div>
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button size="sm" variant='secondary' onClick={ () => {
                            setShowUpdateModal(false)
                            setRegionId(null)
                            setRegionName("")
                        } }>Cancel</Button>
                        <Button disabled={ stringHelpers.isNullOrEmpty(regionName) } size="sm" variant='primary' onClick={ () => handleSubmit() }>Confirm</Button>
                    </Modal.Footer>
                </Modal>
            }
            {
                !stringHelpers.isNullOrEmpty(errorMessage) &&
                <ErrorModal message={ errorMessage } onHide={ () => setErrorMessage(null) } />
            }
            {
                showDeleteModal &&
                <Modal show onHide={ () => {
                    setShowDeleteModal(false)
                    setRegionId(null)
                    setRegionName("")
                } } centered>
                    <Modal.Header>
                        <Modal.Title className="d-flex gap-2 align-items-center">
                            Delete Region
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <p>Are you sure you want to delete the region <b>{regionName}?</b></p>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button size="sm" variant='secondary' onClick={ () => {
                            setShowDeleteModal(false)
                            setRegionId(null)
                            setRegionName("")
                        } }>Cancel</Button>
                        <Button size="sm" variant='danger' onClick={ () => handleDelete() }>Delete</Button>
                    </Modal.Footer>
                </Modal>
            }
        </div>
    )
}